module.exports = __webpack_public_path__ + "img/lataus.83d65c69.png";